import { AuthService } from '~/services/auth/AuthService';
import { FirebaseAuthService } from '~/services/auth/FirebaseAuthService';

export const authService: AuthService = new FirebaseAuthService();
